var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatureStreamlineIconRestApi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 68,
    viewBox: "0 0 64 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "streamline-icon-database-subtract_64x64",
    "data-name": "streamline-icon-database-subtract@64x64",
    transform: "translate(0 -0.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_767",
    "data-name": "Path 767",
    d: "M32,26C15.432,26,2,20.629,2,14S15.432,2,32,2,62,7.373,62,14c0,3.909-4.677,7.384-11.917,9.576",
    fill: "none",
    stroke: "#5f5cd7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_768",
    "data-name": "Path 768",
    d: "M62,28.048V14",
    fill: "none",
    stroke: "#5f5cd7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_769",
    "data-name": "Path 769",
    d: "M2,14V30c0,5.216,8.328,9.659,19.955,11.309",
    fill: "none",
    stroke: "#5f5cd7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_770",
    "data-name": "Path 770",
    d: "M2,30V46c0,5.5,9.269,10.133,21.9,11.557",
    fill: "none",
    stroke: "#5f5cd7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_772",
    "data-name": "Path 772",
    d: "M62,42A20.451,20.451,0,0,1,46,62,20.451,20.451,0,0,1,30,42V32.557a4,4,0,0,1,2.44-3.685,33.448,33.448,0,0,1,27.12,0A4,4,0,0,1,62,32.557Z",
    transform: "translate(0 4.003)",
    fill: "none",
    stroke: "#5f5cd7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureStreamlineIconRestApi);
export default __webpack_public_path__ + "static/media/feature-streamline-icon-rest-api.0e49377b.svg";
export { ForwardRef as ReactComponent };